import classNames from "classnames"
import "./index.less"
import WindFirstPanel from "./first/first"
import WindSecondPanel from "./second/second"
import WindThirdPanel from "./third/third"
import { ModelBase } from "pytha"
import { useEffect, useState } from "react"
import { Sensor } from "@/global/interface/device/sensor"
import { getSensorByPrimitiveUuid } from "@/api/device/sensor"

interface IProps {
    entity: ModelBase
}

export default function AnemoclinographRightMainPanel(props: IProps) {

    const [sensor, setSensor] = useState<Sensor>(null)

    useEffect(() => {
        if (!props?.entity) return;
        generateData();
    }, [props.entity])

    const generateData = () => {
        getSensorByPrimitiveUuid(props.entity.uuid).then(res => {
            setSensor(res.data);
        })
    }


    return (
        <>
            <div className="device-code-area"><span className="device-code">{sensor?.code || ''}</span></div>
            <div className="panel-item">
                <WindFirstPanel sensorId={sensor?.id} />
            </div>
            <div className="panel-item">
                <WindSecondPanel sensorId={sensor?.id} />
            </div>
            <div className="panel-item">
                <WindThirdPanel sensor={sensor} generateData={generateData} />
            </div>
        </>
    )
}